<template>
	<div class="custom-input form-control flex-center ">
		<label class="custom-input-prefix pt-8px">{{ label }}</label>
		<select
			:value="value"
			@input="onChange"
			class="form-control absolute" :class="{'pl-4em': options[0].label !== 'IBM Plex Sans', 'pl-5': options[0].label === 'IBM Plex Sans'}">
			<option
				v-for="(option, index) in options"
				:key="index"
				:value="option[optionValue]">
				{{ option[optionLabel] }}
			</option>
		</select>
	</div>
	<!-- <div class="form-control-select flex-center">
		<select
			class="custom-input-mid select-option"
			:value="value"
			@input="onChange">
			<option
				class="mt-2"
				v-for="(option, index) in options"
				:key="index"
				:value="option[optionValue]">
				{{ option[optionLabel] }}
			</option>
		</select> -->
		<!-- <div class="custom-input-suffix">{{ suffix }}</div> -->
	<!-- </div> -->
</template>

<script>
export default {
	name: 'CustomSelect',
	props: {
		type: {
			type: String,
			default: 'text',
		},
		value: {
		},
		label: {
			type: String,
		},
		suffix: {
			type: String,
			default: '',
		},
		field: {
			type: String,
			default: 'normal',
		},
		options: {
			type: Array,
			default: () => [],
		},
		optionValue: {
			type: String,
			default: 'key',
		},
		optionLabel: {
			type: String,
			default: 'label',
		},
	},
	data() {
		return {};
	},
	methods: {
		onChange(e) {
			let value = e.target.value;
			value = value.trim();
			this.$emit('input', value);
		},
	},
};
</script>

<style>
.select-option{
	width:550px!important;
}
</style>
